export default {"src":"/_next/static/media/globe_24.bc7e9a32.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};